/*********
 Header Sticky
 **********/


/*********
 Desktop Dropdown Menu
 **********/
document.querySelectorAll('.headerNavTitle').forEach(el => {
    el.addEventListener('click', function () {
        let parent = this.closest('.headerNavMenu');
        if (parent.classList.contains('active')) {
            parent.classList.toggle('active');
            document.querySelector("#header").classList.remove("menuOpen");
        } else {
            document.querySelectorAll('.headerNavMenu.active').forEach(el => {
                el.classList.remove('active');
            });
            document.querySelector("#header").classList.add("menuOpen");
            parent.classList.toggle('active');
        }
    })
})

// Backdrop
document.querySelector("#header").addEventListener("click", function (event) {
    if (event.target.id === "headerBackdrop") {
        if (document.querySelector(".headerNavMenu.active")) {
            document.querySelector(".headerNavMenu.active").classList.remove("active");
            document.querySelector("#header").classList.remove("menuOpen");
        }
    }
})

/**************
 Mobile Nav
 ***************/

const slider = document.querySelector("#slider");
const body = document.querySelector("body");
const open = document.querySelector("#headerMenu");
const close = document.querySelector("#sliderClose");

// open nav
function openNav() {
    slider.classList.add("active");
    body.classList.add("noScroll");
    open.classList.add("open");
    close.classList.add("open");
}

// close nav
function closeNav() {
    slider.classList.remove("active");
    body.classList.remove("noScroll");
    open.classList.remove("open");
    close.classList.remove("open");
}

// open nav event listener
open.addEventListener("click", openNav);

//close nav event listener
close.addEventListener("click", closeNav);

/**************
 Mobile Nav Dropdowns
 ***************/

document.querySelectorAll('.sliderProductItemTop').forEach(el => {
    el.addEventListener('click', function () {
        let parent = this.closest('.sliderProductItem');
        parent.classList.toggle('active');
    })
});

/*******************
 Footer Contact
 *******************/

// on click open chat bot
document.querySelector("#footerNavLinksContact").addEventListener("click", function (e) {
    e.preventDefault();
    window.bik_widget.open();
});